import { Route } from '@angular/router';
import { KIDS_HOTELS_PATH, KIDS_HOTELS_TITLE } from '../../mgs-path-defs';
import { mgsIconsResolver } from '../../mgs-svg-icon.helper';
import { kidsDatenResolver } from '../kids-daten.resolver';
import { mgsAuthenticatedGuard } from '../../mgs-guards';

export const kidsHotelRoute: Route = {
  path: KIDS_HOTELS_PATH,
  title: KIDS_HOTELS_TITLE,
  loadComponent: () => import('./kids-hotel.component'),
  canActivate: [mgsAuthenticatedGuard],
  resolve: { kidsDaten: kidsDatenResolver, icons: mgsIconsResolver }
};
